document.addEventListener("DOMContentLoaded", function () {
  var accordionButtons = document.querySelectorAll(
    ".c_accordion_unit .c_accordion_button"
  );

  if (!accordionButtons.length) return;

  accordionButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      var unit = button.closest(".c_accordion_unit");
      if (!unit) return;

      var content = unit.querySelector(".c_accordion_content");
      if (!content) return;

      content.classList.toggle("-open");
      unit.classList.toggle("-open");
    });
  });
});
